import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Message } from 'jl-design-system/components/message/Message';
import { Title } from '~/components';

import styles from './TimeSlot.scss';

import { dateUtils } from '../../utils';

const getDefaultTimeFormat = (startTime, endTime) => (
  <>
    &nbsp;at&nbsp;
    <span>{dateUtils.getTimeSlotFormattedTime(startTime, endTime)}</span>
  </>
);

const getFormattedDate = (selectedDate) =>
  dateUtils.getTimeSlotFormattedDate(dateUtils.getDateFromString(selectedDate));

export class TimeSlot extends PureComponent {
  onChangeClickHandler = (event) => {
    const { history, prevPath } = this.props;
    event.preventDefault();
    if (!prevPath) {
      history.pushWithToken('select-date');
    } else {
      history.pushWithToken(prevPath);
    }
  };

  render() {
    const { selectedDate, startTime, endTime, formatTimeSlot, title } = this.props;
    const format = formatTimeSlot || getDefaultTimeFormat;

    const timeSlotText = (
      <>
        {getFormattedDate(selectedDate)} {format(startTime, endTime)}
      </>
    );

    return (
      <div className={styles.TimeSlot} data-testid="TimeSlot">
        <Title className={styles.Title}>{title}</Title>
        <Message
          buttonProps={{
            onClick: this.onChangeClickHandler,
            className: styles.TimeSlot__change_date,
            tag: 'button',
          }}
          buttonText="Change"
          className={styles.timeSlotMessage}
          title={timeSlotText}
          type="information"
        />
      </div>
    );
  }
}

TimeSlot.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  prevPath: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  formatTimeSlot: PropTypes.func,
  title: PropTypes.string,
};

TimeSlot.defaultProps = {
  formatTimeSlot: null,
  title: 'Your appointment time',
};

export const WithRouterTimeSlot = withRouter(TimeSlot);
